import { useCallback } from 'react';

import { useContractLeadLadderHeadQuery } from 'core/graphql';

import { useLeadPermissions } from './useLeadPermissions';

/**
 * ТЗ 0090 — лид договора для блока лесенок в карточке договора: открыт ли,
 * в воронке ли, не удалён ли, и почему лесенка каждого вида не пошлёт.
 *
 * Роли без доступа к лидам (FinanceManager) запроса не шлют: у них и
 * `crmLead` договора — `null`. Та же запись кэша `KommoLeadType:<id>`, что
 * у карточки лида: действия с лесенками перечитывают карточку, и блок
 * обновляется сам.
 *
 * Сбой запроса — `failed` (с «Повторить»), а не «лид закрыт»: временная
 * ошибка не должна читаться состоянием лида.
 */
export const useContractLeadHead = (leadId: string | null) => {
  const { canUse } = useLeadPermissions();
  const skip = !canUse || !leadId;
  const { data, loading, error, refetch } = useContractLeadLadderHeadQuery({
    variables: { id: leadId || '' },
    skip,
    fetchPolicy: 'cache-and-network',
  });
  const lead = skip ? null : data?.kommoLead ?? null;
  const reload = useCallback(() => {
    refetch()?.catch(() => undefined);
  }, [refetch]);
  return {
    lead,
    loading: !skip && loading && !lead,
    failed: !skip && Boolean(error) && !lead,
    reload,
  };
};
